import { Vehicles } from "../api";
import {
  showLoading,
  showInnerLoading,
  setVehiclesValue,
  setQuotation,
} from "../actions";

export function getUsageAreas() {
  return function func(dispatch) {
    return Vehicles.getUsageAreas().then(response => {
      if (response) {
        dispatch(setVehiclesValue('usageAreas', response));
      }
    });
  };
}

export function getCarBrands(type, isSOA) {

  let codSubramo = '1';
  if (type === 'omnibus' || type === 'camion') codSubramo = '2';

  return function func(dispatch) {
    return Vehicles.getCarBrands(codSubramo, isSOA).then(response => {
      if (response) {
        dispatch(setVehiclesValue('carBrands', response));
        dispatch(setVehiclesValue('carYears',  []));
        dispatch(setVehiclesValue('carModels', []));
        dispatch(setVehiclesValue('carBrand', null));
        dispatch(setVehiclesValue('carYear',  null));
        dispatch(setVehiclesValue('carModel', null));
      }
    });
  };
}

export function setCarBrand(brand) {
  return function func(dispatch, getState) {

    const { vehicles } = getState();
    const { carBrand, vehicleType } = vehicles;

    if (!(carBrand && brand && carBrand.value === brand.value)) {
      dispatch(setVehiclesValue('carBrand',  brand));
      dispatch(setVehiclesValue('carYears',  []));
      dispatch(setVehiclesValue('carModels', []));
      dispatch(setVehiclesValue('carYear',   null));
      dispatch(setVehiclesValue('carModel',  null));

      let codSubramo = '1';
      if (vehicleType === 'omnibus' || vehicleType === 'camion') codSubramo = '2';

      if(brand)
        return Vehicles.getCarYears(brand.value, codSubramo).then(response => {
          if (response) {
            dispatch(setVehiclesValue('carYears', response));
          }
        });
      else return null;
    }
  };
}

export function setCarYear(year) {
  return function func(dispatch, getState) {

    const { vehicles } = getState();
    const { carBrand, carYear, vehicleType } = vehicles;

    if (!(carYear && year && carYear === year)) {
      dispatch(setVehiclesValue('carYear', year));
      dispatch(setVehiclesValue('carModels', []));
      dispatch(setVehiclesValue('carModel', null));

      let codSubramo = '1', codTipoVehiculo = '1';

      switch (vehicleType) {
        case 'auto':
          //Default
          break;
        case 'omnibus':
          codSubramo = '2';
          codTipoVehiculo = '8';
          break;
        case 'camion':
          codSubramo = '2';
          codTipoVehiculo = '2';
          break;
        case 'moto':
          codTipoVehiculo = '11';
          break;
        default:
          break;
      }

      if(year)
        return Vehicles.getCarModels(carBrand.value, year.value, codSubramo, codTipoVehiculo).then(response => {
          if (response) {
            dispatch(setVehiclesValue('carModels', response));
          }
        });
      else return null;
    }
  };
}

export function getQuotation(isFinal = false, isSOA = false) {
  return function func(dispatch, getState) {

    let carBrand, carYear, carModel, carUsageArea, codSubramo, codUso, codManejo;
    const { quoter } = getState().options;
    const { vehicles } = getState();

    //Códigos default
    codSubramo = '1';
    codUso = '1';
    codManejo = '2';

    //Casos testigo default
    carYear = 2016;
    carUsageArea = '1';

    //Códigos y CasTestigo particulares
    if(isFinal) {
      //Cotización final
      carBrand = vehicles.carBrand.value;
      carYear = vehicles.carYear.value;
      carModel = vehicles.carModel.value;
      carUsageArea = vehicles.carUsageArea.value;
      if (vehicles.vehicleType === 'camion') {
        codSubramo = '2'; codUso = '4'; codManejo = '5';
      }
    } else {
      switch (vehicles.vehicleType) {
        case 'auto':
          carBrand = '22';
          carModel = '2055';
          break;
        case 'omnibus':
          carBrand = '47';
          carModel = '2275';
          break;
        case 'camion':
          if (vehicles.truckWeight) { // mayor a 7000 kg
            carBrand = '32';
            carModel = '1009';
          } else { // menor a 7000 kg
            carBrand = '26';
            carYear = 1999;
            carModel = '1005';
            codSubramo = '2';
            codUso = '4';
            codManejo = '5';
          }
          break;
        case 'moto':
          carBrand = '36';
          carYear = 2018;
          carModel = '2031';
          break;
      } 
    }

    if(isFinal) dispatch(showLoading(true));
    else dispatch(showInnerLoading(true));

    return Vehicles.getQuotation(carBrand, carYear, carModel, 
      carUsageArea, codSubramo, codUso, codManejo).then(response => {
      if (response) {
        dispatch(setQuotation(quoter, response, {isFinal: isFinal && isSOA, withOptional: !isSOA, economic: vehicles.economic}));
      } else {
        dispatch(setQuotation(
          quoter, 
          { respuesta: { mensaje: 'Error al obtener la cotización' }}, 
          {isFinal: isFinal && isSOA, withOptional: !isSOA, economic: vehicles.economic}
        ));
      }
      if(isFinal) dispatch(showLoading(false));
      else dispatch(showInnerLoading(false));
    });
  };
}